import React from 'react'
import {
  SellerOutboundReturnCreatePage,
  SellerOutboundReturnDetailPage,
  SellerOutboundReturnListPage
} from 'domains/seller-outbound-return/pages'
// CONSIGNOR_SETTLEMENT_EARLY_WEEK3_PRODUCT_CURATOR_IMPORT_START
import {
  ConsignorSettlementDetailPage,
  ConsignorSettlementsListPage
} from 'domains/consignor-settlements/pages'
// CONSIGNOR_SETTLEMENT_EARLY_WEEK3_PRODUCT_CURATOR_IMPORT_END
import Phase3CreateIntakePage from 'domains/phase3-inbound-journey/pages/Phase3CreateIntakePage'
import Phase3ProductQueuePage from 'domains/phase3-inbound-journey/pages/Phase3ProductQueuePage'
import {
  PHASE3_PRODUCT_SCOPES,
  PHASE3_JULY20_APPRAISAL_NEEDED_ROLES,
  PHASE3_JULY20_APPRAISAL_EMAILS,
  PHASE3_JULY20_CREATE_CONSIGN_EMAILS,
  PHASE3_JULY20_CF_BUYING_PRICE_ROLES,
  PHASE3_JULY20_CF_BUYING_PRICE_EMAILS,
  PHASE3_JULY20_APPRAISAL_APPROVAL_ROLES,
  PHASE3_JULY20_APPRAISAL_APPROVAL_EMAILS
} from 'domains/phase3-inbound-journey/constants'

const PRODUCT_CURATOR_APPRAISAL_ROLES = [ 'owner', 'admin', 'product_curated', 'web', 'stc', 'purchasing' ]
const FINANCE_APPRAISAL_ROLES = [ 'owner', 'admin', 'finance' ]
const BUYING_APPRAISAL_ROLES = [ 'owner', 'admin', 'purchasing' ]
const PRODUCT_CURATOR_SETTLEMENT_ROLES = [ 'owner', 'admin', 'product_curated', 'purchasing' ]
const PRODUCT_CURATOR_SETTLEMENT_EMAILS = [ 'jac@belleandkate.com' ]

const product_curated_team_routes = {
  collapse  : true,
  path      : '/product-curated-team',
  name      : 'Product Curator Team',
  icon      : 'fas fa-box-open text-purple',
  state_key : 'product_curated_team_collapse',
  views     : [

    {
      collapse  : true,
      name      : 'Inbound Journey',
      miniName  : 'IJ',
      state_key : 'product_curated_team_inbound_journey_collapse',
      views     : [
        {
          path         : '/product-curated-team/inbound-journey/create-intake',
          name         : 'Create Consign',
          miniName     : 'CC',
          component    : (props) => <Phase3CreateIntakePage { ...props } apiNamespace='product_curator' />,
          layout        : '/app',
          allowedRoles  : PRODUCT_CURATOR_APPRAISAL_ROLES,
          allowedEmails : PHASE3_JULY20_CREATE_CONSIGN_EMAILS
        },
        {
          path         : '/inbound-journey/appraisal-needed',
          name         : 'Appraisal Needed',
          miniName     : 'AN',
          component     : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.APPRAISAL_NEEDED } title='Appraisal Needed' />,
          layout        : '/app',
          allowedRoles  : PHASE3_JULY20_APPRAISAL_NEEDED_ROLES,
          allowedEmails : PHASE3_JULY20_APPRAISAL_EMAILS
        },
        {
          path         : '/product-curated-team/inbound-journey/bka-appraisal',
          name         : 'BKA Appraisal Edit',
          miniName     : 'BA',
          component    : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.APPRAISAL_NEEDED } title='BKA Appraisal Edit' apiNamespace='finance' />,
          layout       : '/app',
          allowedRoles : FINANCE_APPRAISAL_ROLES,
          invisible    : true
        },
        {
          path         : '/product-curated-team/inbound-journey/bko-appraisal',
          name         : 'BKO Appraisal Edit',
          miniName     : 'BO',
          component    : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.APPRAISAL_NEEDED } title='BKO Appraisal Edit' apiNamespace='buying' />,
          layout       : '/app',
          allowedRoles : BUYING_APPRAISAL_ROLES,
          invisible    : true
        },
        {
          path         : '/inbound-journey/confirm-buying-price',
          name         : 'CF Buying Price',
          miniName     : 'CF',
          component    : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.CONFIRM_BUYING_PRICE } title='CF Buying Price' apiNamespace='product_curator' />,
          layout       : '/app',
          allowedRoles  : PHASE3_JULY20_CF_BUYING_PRICE_ROLES,
          allowedEmails : PHASE3_JULY20_CF_BUYING_PRICE_EMAILS
        },
        {
          path         : '/inbound-journey/appraisal-approval',
          name         : 'Appraisal Approve',
          miniName     : 'AA',
          component     : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.APPRAISAL_APPROVAL } title='Appraisal Approve' />,
          layout        : '/app',
          allowedRoles  : PHASE3_JULY20_APPRAISAL_APPROVAL_ROLES,
          allowedEmails : PHASE3_JULY20_APPRAISAL_APPROVAL_EMAILS
        },
        {
          path         : '/inbound-journey/appraisal-done',
          name         : 'Appraisal Done',
          miniName     : 'AD',
          component     : (props) => <Phase3ProductQueuePage { ...props } scope={ PHASE3_PRODUCT_SCOPES.APPRAISAL_DONE } title='Appraisal Done' />,
          layout        : '/app',
          allowedRoles  : PHASE3_JULY20_APPRAISAL_NEEDED_ROLES,
          allowedEmails : PHASE3_JULY20_APPRAISAL_EMAILS
        }
      ]
    },
    // CONSIGNOR_SETTLEMENT_EARLY_WEEK3_PRODUCT_CURATOR_ROUTES_START
    {
      collapse  : true,
      name      : 'Consignor Settlement',
      miniName  : 'CS',
      state_key : 'product_curated_team_consignor_settlement_collapse',
      views     : [
        {
          path         : '/product-curated-team/consignor-settlement',
          name         : 'Ready for Settlement',
          miniName     : 'RS',
          component    : (props) => (
            <ConsignorSettlementsListPage
              { ...props }
              canNegotiate={ true }
              canSync={ true }
              detailBasePath='/app/product-curated-team/consignor-settlement'
              settlementKind='consignor'
              teamLabel='Product Curator'
            />
          ),
          layout        : '/app',
          allowedRoles  : PRODUCT_CURATOR_SETTLEMENT_ROLES,
          allowedEmails : PRODUCT_CURATOR_SETTLEMENT_EMAILS
        },
        {
          path         : '/product-curated-team/consignor-settlement/:id',
          name         : 'Settlement Detail',
          miniName     : 'SD',
          component    : (props) => (
            <ConsignorSettlementDetailPage
              { ...props }
              canNegotiate={ true }
              canFinanceTransfer={ false }
              listPath='/app/product-curated-team/consignor-settlement'
              settlementKind='consignor'
              teamLabel='Product Curator'
            />
          ),
          layout        : '/app',
          allowedRoles  : PRODUCT_CURATOR_SETTLEMENT_ROLES,
          allowedEmails : PRODUCT_CURATOR_SETTLEMENT_EMAILS,
          invisible     : true
        }
      ]
    },
    // CONSIGNOR_SETTLEMENT_EARLY_WEEK3_PRODUCT_CURATOR_ROUTES_END
    {
      collapse  : true,
      name      : 'Consignor Return',
      miniName  : 'CR',
      state_key : 'product_curated_team_consignor_return_collapse',
      views     : [
        {
          path      : '/product-curated-team/consignor-returns/create',
          name      : 'Consignor Return Create',
          miniName  : 'CRC',
          component : SellerOutboundReturnCreatePage,
          layout    : '/app'
        },
        {
          path      : '/product-curated-team/consignor-returns',
          name      : 'List',
          miniName  : 'L',
          component : SellerOutboundReturnListPage,
          layout    : '/app'
        },
        {
          path      : '/product-curated-team/consignor-returns/:id',
          name      : 'Detail',
          miniName  : 'D',
          component : SellerOutboundReturnDetailPage,
          layout    : '/app',
          invisible : true
        }
      ]
    }
  ]
}

export default product_curated_team_routes